import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BackgroundTaskFactory } from '@nimbus-library/features/background-task/background-task.factory';
import { WindowEventsService } from '@nimbus-library/features/shared/services/window-events.service';
import { ModalService } from '@nimbus-library/features/modal/services/modal.service';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { IPermissionService } from '@nimbus-library/features/feature-permission/services/contracts/i-permission.service';

@Injectable()
export class PermissionService extends IPermissionService {
  private readonly defaultAdminRedirectUrl = 'authentication/admin-consent';
  private readonly defaultUserRedirectUrl = 'authentication/user-consent';

  public constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    authenticationService: IAuthenticationService,
    windowEventsService: WindowEventsService,
    backgroundTaskFactory: BackgroundTaskFactory,
    modalService: ModalService,
    translateService: TranslateService,
  ) {
    super(windowEventsService, authenticationService, backgroundTaskFactory, modalService, translateService);
  }

  public requestUserConsent(scopes: string[], redirectUrl?: string): void {
    redirectUrl = `${this.document.location.protocol}//${this.document.location.host}/${redirectUrl || this.defaultUserRedirectUrl}`;
    this.openPermissionWindow(scopes, redirectUrl);
  }

  public requestAdminConsentLink(scopes: string[], redirectUrl?: string): string {
    redirectUrl = `${this.document.location.protocol}//${this.document.location.host}/${redirectUrl || this.defaultAdminRedirectUrl}`;
    return this.authenticationService.createAdminConsentLink(scopes, redirectUrl);
  }
}
